var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      staticClass: "international",
      attrs: { trigger: "click" },
      on: { command: _vm.handleSetLanguage },
    },
    [
      _c(
        "div",
        [
          _c("svg-icon", {
            attrs: {
              "class-name": "international-icon",
              "icon-class": "settings",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        {
          staticClass: "menu-dropdown",
          attrs: { slot: "dropdown" },
          slot: "dropdown",
        },
        [
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "cn", command: "cn" } },
            [_vm._v("\n      中文\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "en", command: "en" } },
            [_vm._v("\n      English\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }